'use strict';

import * as domUtils from '../../util/dom';
import videoAttributes from '../../util/video-attributes';
var Sizzle = require('sizzle');
import * as Constants from './ui-constants';

var PROPERTY_CLASS = Constants.PROPERTY_CLASS;
var STATE_CLASS = Constants.STATE_CLASS;

var NAMESPACE = 'ui-fullscreen-button';

var CLASSNAMES = {
	fullscreen: 'svp_js-controls-btn--fullscreen',
	fullscreenLabel: 'svp_ui-controls__fullscreen-label'
};

var BUTTON_ICONS = {
	fullscreen: 'svp_ui-controls__button-fullscreen',
	fullscreenEnd: 'svp_ui-controls__button-fullscreen-end'
};

function getCurrentInstanceNamespace(api) {
    // Note that it is not possible to use api.video() here because that is not
    // available before video-load.
    const videoElement = Sizzle('video', api.element())[0];
    const uid = videoAttributes.getUID(videoElement) || videoAttributes.generateAndSetUID(videoElement);

    return `${NAMESPACE}-${uid}`;
}

var createFn = function (api) {

	function _getElement(className) {
		return api && Sizzle('.' + className, api.element())[0];
	}

	function _getFullscreenButton() {
		return _getElement(CLASSNAMES.fullscreen);
	}

	return {

		createElement: function () {
			return domUtils.fromString(
				'<div class=" ' + PROPERTY_CLASS.controlsHideInitially + ' svp_ui-controls--hide-on-error">\
					<button class="' + CLASSNAMES.fullscreen + ' svp_ui-controls__button-fullscreen"\
						aria-live="assertive"\
						title="Aktivera helskärm (F)"\
						tabindex="0">\
						<span class="svp_ui-controls__hidden ' + CLASSNAMES.fullscreenLabel + '">Aktivera helskärm</span>\
					</button>\
				</div>');
		},

		reset: function () {
			var fullscreenButton = _getFullscreenButton();

			if (fullscreenButton) {
				domUtils.removeClass(fullscreenButton, BUTTON_ICONS.fullscreenEnd);
				domUtils.addClass(fullscreenButton, BUTTON_ICONS.fullscreen);
			}
		},

		bindEvents: function (api) {
			domUtils.addEvents(_getFullscreenButton(), 'mousedown, touchstart', function (e) {
				e.stopPropagation();
				e.preventDefault();
			});
			domUtils.addEvents(_getFullscreenButton(), 'click, touchend', function (e) {
				e.stopPropagation();
				e.preventDefault();
				domUtils.toggleVideoFullscreen(api);
			});
			domUtils.addEvents(api.element(), 'dblclick', function (e) {
				e.stopPropagation();
				e.preventDefault();
				domUtils.toggleVideoFullscreen(api);
			});
			domUtils.addEvents(document, 'fullscreenchange, mozfullscreenchange, MSFullscreenChange, webkitfullscreenchange',
				function () {
					var fullscreenButton = _getFullscreenButton(),
						fullscreenLabel = _getElement(CLASSNAMES.fullscreenLabel),
						isFullscreen = domUtils.isFullscreen(),
						_focusElement = Sizzle('.' + Constants.FOCUS_ELEMENT_CLASS)[0],
						label = isFullscreen ? 'Avsluta helskärm' : 'Aktivera helskärm';
					if (isFullscreen) {
						domUtils.removeClass(fullscreenButton, BUTTON_ICONS.fullscreen);
						domUtils.addClass(fullscreenButton, BUTTON_ICONS.fullscreenEnd);
						if (document.activeElement !== fullscreenButton) {
							api.element().setAttribute('tabindex', '0');
							_focusElement.removeAttribute('tabindex');
							api.element().focus();
						}
						domUtils.addClass(api.element(), STATE_CLASS.fullscreen);
					} else {
						domUtils.removeClass(fullscreenButton, BUTTON_ICONS.fullscreenEnd);
						domUtils.addClass(fullscreenButton, BUTTON_ICONS.fullscreen);
						domUtils.removeClass(api.element(), STATE_CLASS.fullscreen);
					}
					fullscreenButton.setAttribute('title', label + ' (F)');
					fullscreenLabel.innerHTML = label;

				}, getCurrentInstanceNamespace(api));

			domUtils.addEvents(_getFullscreenButton(), 'keyup', function (e) {
				var keyName = domUtils.getKeyFromKeyEvent(e);

				if (keyName === 'enter') {
					e.preventDefault();
					e.stopPropagation();

					return true;
				}

				return false;
			});
		}
	};

};

module.exports = {
	create: createFn,
	destroy: function (api) {
        const currentInstanceNamespace = getCurrentInstanceNamespace(api);
		var fullscreenButton = Sizzle('.' + CLASSNAMES.fullscreen, api.element())[0];
		if (fullscreenButton) {
			domUtils.removeEvents(fullscreenButton, 'click, touchend');
			fullscreenButton.parentElement.removeChild(fullscreenButton);
		}
		domUtils.removeEvents(api.element(), 'dblclick');
		domUtils.removeEvents(document, 'fullscreenchange, mozfullscreenchange, MSFullscreenChange, webkitfullscreenchange', currentInstanceNamespace);
	}
};




// WEBPACK FOOTER //
// ./src/js/plugins/ui/fullscreen-button.js